// extracted by mini-css-extract-plugin
module.exports = {"locl-getting-started":"getting-started_locl-getting-started__SWxw0","locl-getting-started__list":"getting-started_locl-getting-started__list__qApSP"};